module.exports = __webpack_public_path__ + "static/media/pinkThyroid.8d0a9153.png";